import React from 'react';
import DesktopSidebar from './DesktopSidebar';
import MobileDrawer from './navigation/MobileDrawer';
import AppTopBar from './AppTopBar';
import SupportModeBanner from './SupportModeBanner';
import DashboardBanner from './DashboardBanner';
import AppLegalFooter from './AppLegalFooter';
import { NavigationProvider, useNavigation } from '@/context/NavigationContext';
import { Outlet } from 'react-router-dom';
import { useMe } from '@/context/MeContext';
import { useWorkspace } from '@/context/WorkspaceContext';

function LayoutShell() {
  const { me } = useMe();
  const { workspaceScopeKey } = useWorkspace();
  const { isCompactNav, breakpoint, sidebarCollapsed } = useNavigation();
  const showRuntime = Boolean(me?.permissions.canViewSystemDashboard || me?.permissions.canViewRuntime);

  return (
    <div
      className={`layout layout--${breakpoint}${isCompactNav ? ' layout--compact-nav' : ''}${
        !isCompactNav && sidebarCollapsed ? ' layout--sidebar-collapsed' : ''
      }`}
    >
      {isCompactNav ? <MobileDrawer /> : <DesktopSidebar />}

      <main className="content">
        <SupportModeBanner />
        {!isCompactNav ? <AppTopBar showRuntime={showRuntime} /> : null}
        <DashboardBanner />
        <div className="content-inner">
          <Outlet key={workspaceScopeKey} />
        </div>
        <AppLegalFooter />
      </main>
    </div>
  );
}

export default function Layout() {
  return (
    <NavigationProvider>
      <LayoutShell />
    </NavigationProvider>
  );
}
